// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Lc0J","row":"styles_row__3OEwz"};